// Image Zoom Lightbox for Product Descriptions
document.addEventListener('DOMContentLoaded', function() {
  // Create lightbox overlay
  const lightbox = document.createElement('div');
  lightbox.id = 'image-lightbox';
  lightbox.style.cssText = `
    display: none;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    justify-content: center;
    align-items: center;
  `;
  
  const lightboxImg = document.createElement('img');
  lightboxImg.style.cssText = `
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  `;
  
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '&times;';
  closeBtn.style.cssText = `
    position: absolute;
    top: 20px;
    right: 40px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 10000;
  `;
  
  lightbox.appendChild(lightboxImg);
  lightbox.appendChild(closeBtn);
  document.body.appendChild(lightbox);
  
  // Add click handlers to product description images
  const descriptionImages = document.querySelectorAll('.product-description img, .rte img, [class*="description"] img');
  
  descriptionImages.forEach(img => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', function() {
      lightboxImg.src = this.src;
      lightbox.style.display = 'flex';
    });
  });
  
  // Close lightbox
  function closeLightbox() {
    lightbox.style.display = 'none';
  }
  
  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });
  
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.style.display === 'flex') {
      closeLightbox();
    }
  });
});
